module.exports = __webpack_public_path__ + "img/bankAccount.84ec88b1.svg";